module.exports = __webpack_public_path__ + "static/paulette_1-74aa9a4679b7bdc8eb7a573992c00826.jpg";